import React, { useState, useEffect, useRef } from 'react';
import './LeavecargoSession.css';

function LeavecargoSession() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  const stats = [
    { id: 1, icon: "./Logo/ports-icon.webp", number: 130, label: "Plus Ports", suffix: "" },
    { id: 2, icon: "./Logo/positivity-icon.webp", number: 95, label: "Customer Positivity Rate", suffix: "%" },
    { id: 3, icon: "./Logo/shipments-icon.webp", number: 10000, label: "Shipments Completed in 2024", suffix: "" },
  ];

  // Check if section is visible in viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.disconnect();
      }
    };
  }, []);

  // Counter animation component
  const Counter = ({ end, duration = 2000, suffix = "" }) => {
    const [count, setCount] = useState(0);
    
    useEffect(() => {
      if (!isVisible) return;
      
      let startTime;
      let animationFrame;
      
      const animate = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = timestamp - startTime;
        const percentage = Math.min(progress / duration, 1);
        
        setCount(Math.floor(percentage * end));
        
        if (percentage < 1) {
          animationFrame = requestAnimationFrame(animate);
        }
      };
      
      animationFrame = requestAnimationFrame(animate);
      
      return () => cancelAnimationFrame(animationFrame);
    }, [end, duration, isVisible]);
    
    // Format large numbers with commas
    const formatNumber = (num) => {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    
    return <span>{formatNumber(count)}{suffix}</span>;
  };

  return (
    <div className="leavecargo-session" ref={sectionRef}>
      <div className="leavecargo-white-gap top"></div>
      <div className="leavecargo-container">
        <div className="leavecargo-header">
          <h2>LEAVE THE CARGO TO US</h2>
        </div>
        
        <div className="stats-container">
          {stats.map(stat => (
            <div key={stat.id} className="stat-item">
              <div className="stat-icon">
                <img src={stat.icon} alt={stat.label} className="icon-image" />
              </div>
              <div className="stat-number">
                {isVisible ? <Counter end={stat.number} suffix={stat.suffix} /> : `0${stat.suffix}`}
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="leavecargo-white-gap bottom"></div>
    </div>
  );
}

export default LeavecargoSession;
